class CardCarousel extends window.BAO.CustomElement() {
  constructor () {
    super()
    this.splide = null
  }

  connectedCallback () {
    super.connectedCallback()

    window.addEventListener('load', () => {
      this.initializeCarousel()
    })
  }

  disconnectedCallback () {
    if (super.disconnectedCallback) super.disconnectedCallback()

    if (this.splide) {
      this.splide.destroy()
      this.splide = null
    }
  }

  initializeCarousel () {
    this.splide = new Splide(this.els.slider.element, {
      type: 'slide',
      pagination: false,
      gap: 25,
      perPage: 3,
      drag: true,
      arrows: false,
      updateOnMove: true,
      focus: 0,
      waitForTransition: true,
      speed: 600,
      flickPower: 300,
      flickMaxPages: 1,
      breakpoints: {
        959: {
          perPage: 2,
          gap: 20,
          flickPower: 200,
        },
        767: {
          perPage: 1.25,
          gap: 15,
          flickPower: 150,
        },
      },
    })

    this.splide.mount()

    // Update data-initialized attribute after mounting
    this.els.slider.element.setAttribute('data-initialized', 'true')
  }
}

if (!customElements.get('card-carousel')) {
  customElements.define('card-carousel', CardCarousel)
}
